import React from 'react';
import city from '@design-system/Assets/rider.png';
import deliveryGuy from '@design-system/Assets/deliveryGuy.svg';
import chef from '@design-system/Assets/chef.png';
import banner from '@design-system/Assets/banner.png';
import FaqItem from './components/FAQ';
import Header from '@app/marketplace/components/Header';
import Footer from '@app/marketplace/components/Footer';
import appleDownload from '@design-system/Assets/apple_badge.png';
import googleDownload from '@design-system/Assets/google_badge.png';

import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Offering from './components/Offering';

export default function Home() {
  const faqData = [
    {
      question: 'Who is Akaani?',
      answer:
        'Akaani is a supply-chain startup that combines an AI-powered marketplace and recipe platform to create a one-of-a-kind commerce experience for African grocery customers and sellers. By utilizing innovative technology, Akaani streamlines the shopping process, enhances customer satisfaction, and helps businesses reach their full potential.',
    },
    {
      question: 'What is sella by akaani?',
      answer:
        'Sella by akaani is a business management app that helps grocery and foodstuff vendors sell better. Sella provides tools for setting up and managing storefronts, tracking inventory and delivery, monitoring sales and building customer relationships. It is designed to cater to the specific needs of business in the food industry.',
    },
    {
      question: 'What can I sell on Sella?',
      answer:
        'You can sell all food produce. From fresh to Dry products. Everything in the food industry.',
    },
    {
      question: 'Where and how can I share my store link?',
      answer:
        'You can add to your Instagram page, your WhatsApp status and any other social media platform. You can even share to your contacts directly.',
    },
  ];

  return (
    <div>
      <Header active={'home'} />
      <main>
        <section className="flex flex-col items-center bg-landing text-white py-32">
          <h2 className="text-3xl lg:text-5xl lg:w-3/5 text-center font-bold">
            akaani mobile app is launching in the USA!
          </h2>
          <p className="w-4/5 lg:w-7/12 text-center mt-6 md:mt-4">
            Your one-stop marketplace for authentic African recipes and fresh,
            locally-sourced ingredients delivered straight to your door
          </p>
          <div className="flex gap-6 mt-10">
            <div>
              <a href="https://apps.apple.com/ng/app/akaani-partners-sell-online/id1667139572?uo=2">
                <img src={appleDownload} alt="apple store logo" />
              </a>
            </div>
            <div>
              <a href="https://play.google.com/store/apps/details?id=com.useakaani.app">
                <img src={googleDownload} alt="google play store logo" />
              </a>
            </div>
          </div>
        </section>
        <section className="flex flex-col md:flex-row md:pt-10 lg:mt-0  bg-ak50">
          <div className="flex flex-col flex-1 md:px-10 lg:px-16 lg:pt-28 pb-20">
            <h3 className="text-center md:text-left text-3xl lg:text-5xl md:text-4x px-2 md:px-0 mt-10 md:mt-0 font-bold text-ak100  lg:w-4/5">
              Explore your favorite city&#39;s African taste
            </h3>
            <p className="mt-4 text-center md:text-left px-6 md:px-0 font-light lg:text-xl lg:w-5/6">
              There&#39;s something truly magical about savoring the flavors of a
              city that holds a special place in your heart. When it comes to African
              food, your favorite city becomes a culinary wonderland waiting to be
              explored.
            </p>
          </div>
          <div className="flex-1">
            <img src={city} className="" />
          </div>
        </section>
        <Offering />
        <section className="flex flex-col md:flex-row justify-center md:gap-10 lg:gap-12 items-center px-6 lg:px-16 md:mt-14">
          <div className="flex-1">
            <h3 className="text-ak200 text-xl lg:text-4xl lg:w-3/5 font-bold mt-10 md:mt-24 lg:mt-0">
              Shop on akaani Marketplace
            </h3>
            <p className="mt-5 lg:w-9/12">
              Find the heart of African cuisine with our marketplace, your gateway to
              local sellers in Nigeria and the USA, delivering the essence of
              traditional dishes right to your doorstep.
            </p>
            <Link
              className="landing-button mt-5 block font-bold mb-10 md:mb-0"
              to="/marketplace"
            >
              Get Started{' '}
            </Link>
          </div>
          <div className="flex-1">
            <img src={deliveryGuy} alt="A delivery man" />
          </div>
        </section>
        <section className="flex flex-col md:flex-row justify-between  md:gap-10 lg:gap-16 items-center px-6 lg:px-16 mt-24 ">
          <div className="flex-1 order-2 md:order-1">
            <img src={chef} alt="A delivery man" />
          </div>
          <div className="flex-1 md:order-2">
            <h3 className="text-ak200 text-xl lg:text-4xl lg:w-2/5 font-bold mt-10 md:mt-10 lg:mt-20">
              Become a <br className="hidden lg:block" />
              sella
            </h3>
            <p className="mt-5 lg:w-9/12">
              Are you ready to bring the vibrant world of African cuisine and
              groceries to the digital stage? With the Sella app, you can create your
              very own personal and professional web storefront in less than 30
              minutes, and it&#39;s tailor-made for your food and grocery business.
            </p>
            <Link
              className="landing-button mt-5 block font-bold mb-10 md:mb-0"
              to="/marketplace"
            >
              Get Started{' '}
            </Link>
          </div>
        </section>

        <section className="w-full px-6 md:px-0 md:w-4/5 mx-auto md:mt-20">
          <h5 className="text-center font-semibold mt-14 md:mt-0 text-ak200">
            FAQs
          </h5>
          <h2 className="text-center font-bold lg:text-5xl mb-16 text-2xl ">
            Frequently asked questions
          </h2>
          {faqData.map((faq, index) => (
            <FaqItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isLastItem={index === faqData.length - 1}
            />
          ))}
        </section>

        <section className="flex flex-col md:flex-row justify-between bg-ak50 py-8 rounded-lg px-6 md:px-10 shadow-md mx-6 md:mx-8 lg:mx-16 items-center mt-16">
          <div className="text-center md:text-left">
            <h4 className="font-bold mb-2">Have more questions?</h4>
            <p>Contact our team and someone will get in touch with you.</p>
          </div>
          <div>
            <a
              className="bg-ak100 px-6 py-3 block text-white text-center rounded-md w-full mt-8"
              href="mailto:support@useakaani.com"
            >
              Contact Us
            </a>
          </div>
        </section>

        <div className="mt-16 md:mx-8 lg:mx-20">
          <img src={banner} alt="akaani mobile app ad banner" />
        </div>
      </main>
      <Footer />
    </div>
  );
}
